/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShockProfileCreate
 */
export interface ShockProfileCreate {
    /**
     * The name of the shock profile.
     * @type {string}
     * @memberof ShockProfileCreate
     */
    label: string;
    /**
     * The threshold for light shock events. The value is measured in g-force.
     * @type {number}
     * @memberof ShockProfileCreate
     */
    light: number;
    /**
     * The threshold for medium shock events. The value is measured in g-force.
     * @type {number}
     * @memberof ShockProfileCreate
     */
    medium: number;
    /**
     * The threshold for severe shock events. The value is measured in g-force.
     * @type {number}
     * @memberof ShockProfileCreate
     */
    severe: number;
    /**
     * There must be elevated gforce values for this amount of time, before we consider the current event an actual crash. The unit of this value are milliseconds. System time resolution is one second and shock won't last more.
     * @type {number}
     * @memberof ShockProfileCreate
     */
    duration: number;
    /**
     * Scale the measured x-axis value by this value before calculating g-force value.
     * @type {number}
     * @memberof ShockProfileCreate
     */
    xAxisScale: number;
    /**
     * Scale the measured y-axis value by this value before calculating g-force value.
     * @type {number}
     * @memberof ShockProfileCreate
     */
    yAxisScale: number;
    /**
     * Scale the measured z-axis value by this value before calculating g-force value.
     * @type {number}
     * @memberof ShockProfileCreate
     */
    zAxisScale: number;
}

/**
 * Check if a given object implements the ShockProfileCreate interface.
 */
export function instanceOfShockProfileCreate(value: object): value is ShockProfileCreate {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('light' in value) || value['light'] === undefined) return false;
    if (!('medium' in value) || value['medium'] === undefined) return false;
    if (!('severe' in value) || value['severe'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('xAxisScale' in value) || value['xAxisScale'] === undefined) return false;
    if (!('yAxisScale' in value) || value['yAxisScale'] === undefined) return false;
    if (!('zAxisScale' in value) || value['zAxisScale'] === undefined) return false;
    return true;
}

export function ShockProfileCreateFromJSON(json: any): ShockProfileCreate {
    return ShockProfileCreateFromJSONTyped(json, false);
}

export function ShockProfileCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShockProfileCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'light': json['light'],
        'medium': json['medium'],
        'severe': json['severe'],
        'duration': json['duration'],
        'xAxisScale': json['xAxisScale'],
        'yAxisScale': json['yAxisScale'],
        'zAxisScale': json['zAxisScale'],
    };
}

export function ShockProfileCreateToJSON(json: any): ShockProfileCreate {
    return ShockProfileCreateToJSONTyped(json, false);
}

export function ShockProfileCreateToJSONTyped(value?: ShockProfileCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'light': value['light'],
        'medium': value['medium'],
        'severe': value['severe'],
        'duration': value['duration'],
        'xAxisScale': value['xAxisScale'],
        'yAxisScale': value['yAxisScale'],
        'zAxisScale': value['zAxisScale'],
    };
}

